import { z } from 'zod';
import { projectsProjectSummarySchema } from './projects-project.contract.js';
export const projectsFinanceProfitabilityIndexCapability = 'projects.finance-profitability-index.v1';
export const projectsFinanceProfitabilityIndexSlot = 'finance.project-profitability.projects';
export const projectsFinanceProfitabilityIndexProviderId = 'projects.server.finance-profitability-index';
export const projectsFinanceProfitabilityIndexRequestSchema = z.strictObject({
    consumerModuleId: z.literal('finance'),
    requestedCapability: z.literal('finance.project-profitability.v1'),
    resourceType: z.literal('finance.project-profitability'),
    resourceId: z.string().uuid(),
    maximumProjects: z.number().int().min(1).max(500),
});
export const projectsFinanceProfitabilityProjectSchema = projectsProjectSummarySchema.pick({
    id: true,
    projectNumber: true,
    name: true,
    status: true,
    revision: true,
    createdAt: true,
    updatedAt: true,
});
export const projectsFinanceProfitabilityIndexResponseSchema = z.strictObject({
    contractVersion: z.literal(projectsFinanceProfitabilityIndexCapability),
    tenantId: z.string().uuid(),
    totalProjects: z.number().int().nonnegative(),
    truncated: z.boolean(),
    projects: z.array(projectsFinanceProfitabilityProjectSchema).max(500),
}).superRefine((response, context) => {
    if (response.projects.length > response.totalProjects) {
        context.addIssue({
            code: 'custom',
            path: ['totalProjects'],
            message: 'The Projects profitability total cannot be below the returned count.',
        });
    }
    if (response.truncated !== (response.projects.length < response.totalProjects)) {
        context.addIssue({
            code: 'custom',
            path: ['truncated'],
            message: 'The Projects profitability truncation flag does not match the returned count.',
        });
    }
    const ids = response.projects.map(({ id }) => id);
    if (new Set(ids).size !== ids.length) {
        context.addIssue({ code: 'custom', path: ['projects'], message: 'Projects cannot repeat.' });
    }
});
//# sourceMappingURL=projects-finance-profitability-index.contract.js.map